import React, { useEffect, useState } from "react";
import Fotter from "./Fotter";
import Navbar from "./Navbar";
import { Link } from "react-router-dom";
import SettingSidebar from "./SettingSidebar";
import Cookies from "js-cookie";
import { BASE_URL } from "../Pages/Config";
import BuyerName from "../components/BuyerNameRewview";
import Swal from "sweetalert2";

import "../components/SettingCharges.css";

export default function SettingCharges() {
  const [charges, setUserCharges] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    total: 0,
    paid: 0,
    pending: 0,
    pendingAmount: 0,
  });

  // console.log("charges", charges);

  const user_id = Cookies.get("user_id");

  const usercharges = async () => {
    try {
      setLoading(true);
      const res = await fetch(
        `${BASE_URL}/user_charges_count.php?user_id=${user_id}&t=${Date.now()}`,
        { cache: "no-store" },
      );

      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

      const data = await res.json();
      if (data.success) {
        setUserCharges(data.data);

        // ✅ Calculate summary stats
        const total = data.data.length;
        let paid = 0,
          pending = 0,
          pendingAmount = 0;

        data.data.forEach((item) => {
          const isSeller = parseInt(user_id) === parseInt(item.seller_id);
          const statusValue = isSeller
            ? item.charges_paid_status_seller
            : item.charges_paid_status_buyer;
          const isPaid = statusValue?.toLowerCase() === "paid";

          if (isPaid) {
            paid++;
          } else {
            pending++;
            pendingAmount += parseFloat(
              item.buy_product_status == 0 ? item.current_price : item.buy_now,
            );
          }
        });

        setStats({ total, paid, pending, pendingAmount });
      }
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    usercharges();
  }, []);

  const payCharges = async (id, amount) => {
    setLoading(true);
    try {
      const res = await fetch(
        `${BASE_URL}/pay_single_charges_process.php?charge_id=${id}&user_id=${user_id}&amount=${amount}&t=${Date.now()}`,
      );

      // const data = await res.text();

      // console.log(data)
      const data = await res.json();

      if (data.success) {
        // Redirect to Paymob checkout
        window.location.href = data.redirection_url;
      } else {
        Swal.fire({
          icon: "error",
          title: "Payment Error",
          text: data.message || "Something went wrong",
        });
      }

      updateNotifications();
      usercharges();
    } catch (error) {
      console.error("Payment failed", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Payment failed. Try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  // ✅ Pay All Pending Charges
  const payAllCharges = async () => {
    if (userChargesTotal === 0) {
      Swal.fire({
        icon: "info",
        title: "No Pending Charges",
        text: "You don't have any pending charges to pay.",
      });
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: `You are about to pay ${stats.pending} charges (${userChargesTotal} SAR).`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Pay All",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          const response = await fetch(
            `${BASE_URL}/pay_all_charges_process.php?user_id=${user_id}&amount=${userChargesTotal}&t=${Date.now()}`,
          );

          // const res = await response.text();

          // console.log(res)
          const data = await response.json(); // ✅ IMPORTANT

          // console.log(data)
          if (data.success) {
            // Redirect to Paymob checkout
            window.location.href = data.redirection_url;
          } else {
            Swal.fire({
              icon: "error",
              title: "Payment Error",
              text: data.message || "Something went wrong",
            });
          }

          updateNotifications();
          usercharges();
        } catch (error) {
          console.error("Pay All failed", error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Payment failed. Try again.",
          });
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const [userChargesTotal, setUserChargesTotal] = useState(0);

  const updateNotifications = async () => {
    const user_id = Cookies.get("user_id");

    try {
      const res = await fetch(
        `${BASE_URL}/user_charges_count.php?user_id=${user_id}&t=${Date.now()}`,
        { cache: "no-store" },
      );

      const data = await res.json();
      // console.log("Charges Total:", data);

      if (data.success) {
        setUserChargesTotal(data.unpaid_total); // ✅ Update state
        console.log("Charges Unpaid Amount:", data.unpaid_total);
      } else {
        console.log("Error:", data.message);
      }
    } catch (err) {
      console.error("Fetch failed:", err);
    }
  };
  useEffect(() => {
    updateNotifications();
  }, []);

  return (
    <>
      <Navbar />
      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">
                  <p>HOME </p>
                </Link>
                <span> /</span>
                <p>CHARGES</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Charges Page */}
      <div className="page-settings">
        <div className="container">
          <div className="row">
            <SettingSidebar />

            <div className="col-sm-12 col-md-12 col-lg-9 col-xl-9">
              <div
                className="setting-info"
                style={{ backgroundColor: "#ffffff00" }}
              >
                <h3 className="charges-title">My Charges</h3>

                {/* ✅ Summary Section */}
                <div className="charges-summary">
                  <div className="summary-card">
                    <h5>Total Products</h5>
                    <p>{stats.total}</p>
                  </div>
                  <div className="summary-card">
                    <h5>Paid</h5>
                    <p className="status-paid">{stats.paid}</p>
                  </div>
                  <div className="summary-card">
                    <h5>Pending</h5>
                    <p className="status-pending">{stats.pending}</p>
                  </div>
                  <div className="summary-card">
                    <h5>Pending Amount</h5>
                    <p>{userChargesTotal} SAR</p>
                  </div>
                </div>

                {/* ✅ Inside each charge card */}

                {userChargesTotal > 1 && (
                  <div
                    className="charge-footer"
                    style={{ marginBottom: "5px" }}
                  >
                    <button
                      className="btn-pay-all"
                      onClick={payAllCharges}
                      title={`This will pay all ${userChargesTotal} pending charges.`}
                    >
                      Pay Pending all amount ({userChargesTotal} SAR)
                    </button>
                  </div>
                )}

                <div className="row">
                  {loading ? (
                    <div
                      className="loading-overlay"
                      style={{
                        height: "550px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div className="dot-spinner">
                        {[...Array(8)].map((_, i) => (
                          <div key={i} className="dot-spinner__dot"></div>
                        ))}
                      </div>
                    </div>
                  ) : charges.length > 0 ? (
                    charges.map((item) => {
                      const isSeller =
                        parseInt(user_id) === parseInt(item.seller_id);
                      const statusValue = isSeller
                        ? item.charges_paid_status_seller
                        : item.charges_paid_status_buyer;
                      const isPaid = statusValue?.toLowerCase() === "paid";

                      return (
                        <div
                          key={item.charge_id}
                          className="col-sm-12 col-md-6 col-lg-6 p-2"
                        >
                          <div className="charge-card">
                            <Link to={`/detail/${item.product_id}`}>
                              <div className="charge-header">
                                <img
                                  src={`${BASE_URL}/${
                                    item.photo?.split(",")[0]?.trim() ||
                                    "uploads/logo/icon.png"
                                  }`}
                                  alt={item.title || "Product"}
                                />
                                <div>
                                  <h5>{item.title}</h5>
                                  <p className="price">
                                    {item.buy_product_status == 0
                                      ? item.current_price
                                      : item.buy_now}{" "}
                                    SAR
                                  </p>
                                </div>
                              </div>
                            </Link>
                            <div style={{ display: "flex" }}>
                              {/* User Info */}
                              <div
                                className="user-info"
                                style={{ width: "50%" }}
                              >
                                <p>
                                  Seller:{" "}
                                  <strong>
                                    <BuyerName buyerId={item.seller_id} />
                                  </strong>
                                </p>
                                <p>
                                  Buyer:{" "}
                                  <strong>
                                    <BuyerName buyerId={item.buyer_id} />
                                  </strong>
                                </p>
                                <p>
                                  Charges:{" "}
                                  <p>
                                    <strong>
                                      {parseInt(user_id) ===
                                      parseInt(item.seller_id)
                                        ? item.seller_charge
                                        : item.buyer_charge}{" "}
                                      SAR
                                    </strong>
                                  </p>
                                </p>
                                <p>
                                  Status:{" "}
                                  <span className={isPaid ? "paid" : "pending"}>
                                    {statusValue}
                                  </span>
                                </p>
                              </div>

                              {/* Purchase / Auction Details */}
                              <div
                                className="purchase-info"
                                style={{ width: "50%" }}
                              >
                                <p>
                                  Location:{" "}
                                  <p>
                                    <strong>
                                      {item.neighborhood
                                        ? `${item.neighborhood},`
                                        : ""}
                                      {item.location
                                        ? ` ${item.location}, Saudi Arabia`
                                        : ""}
                                    </strong>
                                  </p>
                                </p>

                                <p>
                                  Shipping:{" "}
                                  <p>
                                    <strong>
                                      {item.shipping || "Not specified"}
                                    </strong>
                                  </p>
                                </p>
                              </div>
                            </div>

                            <div className="charge-footer">
                              {/* <Link
                                to={`/charges_detail/${item.id}`}
                                className="btn-detail"
                              >
                                View Details
                              </Link> */}

                              {!isPaid && (
                                <button
                                  className="btn-pay"
                                  onClick={() =>
                                    payCharges(
                                      item.id,
                                      parseInt(user_id) ===
                                        parseInt(item.seller_id)
                                        ? item.seller_charge
                                        : item.buyer_charge,
                                    )
                                  }
                                >
                                  Pay Now
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <p className="no-charges">No charges found.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Fotter />
    </>
  );
}
